module.exports = "h1 {\r\n    color: #fff;\r\n}\r\np {\r\n    color: #fff;\r\n}\r\ni {\r\n    font-size: 42px;\r\n}"